import client from "./clients/portalClient";

const getWeekstaat = (data) => client.get(`/timesheet`, data);
const resetWeekstaat = (data) => client.delete(`/timesheet`, data);
const toggleWeekstaat = (data) => client.put(`/timesheet/status`, data);

const postWeekstaatItem = (data) => client.post(`/timesheet/detail`, data);
const editWeekstaatItem = (id,data) => client.put(`/timesheet/detail/${id}`, data);
const deleteWeekstaatItem = (id) => client.delete(`/timesheet/detail/${id}`);

const weekstatenApi = {
  getWeekstaat,
  resetWeekstaat,
  toggleWeekstaat,

  postWeekstaatItem,
  editWeekstaatItem,
  deleteWeekstaatItem
};

export default weekstatenApi;
